import React from "react";
import classes from "./AlertWithCheckbox.scss";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import I18nHOC from "UIComponents/I18nHOC";
import { compose } from "lib/apolloClient";
import { Alert } from "@toddle-edu/ds-web";
import PropTypes from "prop-types";

class AlertWithCheckbox extends UIBaseComponent {
  constructor(props) {
    super(props);
  }

  renderAlertComponent = () => {
    const {
      value,
      disabled,
      t,
      title,
      localisedTitle,
      message,
      localisedMessage,
      alertType,
      showIcon,
      dsVersion,
      testId,
      alertContainerStyle,
    } = this.props;

    return (
      <div className={classes.container} style={alertContainerStyle}>
        <Alert
          type={alertType}
          showIcon={showIcon}
          title={localisedTitle ? t(localisedTitle) : title}
          message={localisedMessage ? t(localisedMessage) : message}
          isChecked={value}
          onChange={() => this.updateValue(!value)}
          disabled={disabled}
          dsVersion={dsVersion}
          testId={testId}
        />
      </div>
    );
  };

  renderView = () => {
    return this.renderAlertComponent();
  };

  renderEdit = () => {
    return this.renderAlertComponent();
  };
}

AlertWithCheckbox.defaultProps = {
  ...UIBaseComponent.defaultProps,
  title: "",
  localisedTitle: "",
  message: "",
  localisedMessage: "",
  alertType: "info",
  showIcon: false,
  dsVersion: "1.0",
  testId: "alertWithCheckbox",
};

AlertWithCheckbox.propTypes = {
  ...UIBaseComponent.propTypes,
  title: PropTypes.string,
  localisedTitle: PropTypes.string,
  message: PropTypes.string,
  localisedMessage: PropTypes.string,
  alertType: PropTypes.string,
  showIcon: PropTypes.bool,
  dsVersion: PropTypes.string,
  testId: PropTypes.string,
};

export default compose(
  I18nHOC({ resource: ["projectTemplate", "project", "common"] })
)(AlertWithCheckbox);
